import { BOOLEAN_NUMBER } from "@app/shared/common-enums/boolean-number";
import { RoType } from "../interface/ro-type";
import { Utilities } from "./utilities";

export class RoTypeUtilities extends Utilities {

  static changed(a: RoType, b: RoType): boolean {
    return !this.equalString(a.code?.toString(), b.code?.toString()) || !this.equalString(a.type, b.type);
  }

  /**
   * Types that may be offered for a NEW assignment (creating/changing an OS or budget's
   * type, grouping, scheduling, packages, AI-assisted registration, etc). An explicit
   * `active === BOOLEAN_NUMBER.FALSE` is inactive; missing/undefined is treated as active
   * to stay compatible with legacy records that predate the `active` field.
   *
   * Never apply this to a historical reader (reports, audit logs, already-persisted
   * document display) — those must keep resolving inactive types normally.
   */
  static onlyActive(roTypes: RoType[] = []): RoType[] {
    return (roTypes || []).filter(roType => roType?.active !== BOOLEAN_NUMBER.FALSE);
  }

  /**
   * Keeps a selector's option list able to display an already-persisted type even when it
   * has since been inactivated (or is otherwise missing from an active-only list), so a
   * control bound to that value never silently renders blank/empty.
   * Mirrors `Utilities.withSeededPerson`.
   */
  static withSelected(roTypes: RoType[], seed?: RoType | null): RoType[] {
    if (!seed?.id) {
      return roTypes || [];
    }
    return (roTypes || []).some(roType => roType.id === seed.id) ? roTypes : [seed, ...(roTypes || [])];
  }

}
